import { ACTION_TYPES } from '../constants';

export default path => ({
  type: ACTION_TYPES.SET_CURRENT_PATH,
  payload: {
    path
  }
});
